/** Packages **/
import React from 'react';
import PropTypes from 'prop-types';

const LinearCalendarHeader = props => (
  <div>
    { props.head }
  </div>
);

LinearCalendarHeader.propTypes = {
  head: PropTypes.any.isRequired
};

export default LinearCalendarHeader;
